"use client";

import React, { useState, useEffect, ComponentProps } from "react";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";

type DrawerProps = ComponentProps<typeof Drawer>;

export type SEOFriendlyDrawerProps = Omit<
  DrawerProps,
  "disablePortal" | "keepMounted"
>;

export const SEOFriendlyDrawer = (props: SEOFriendlyDrawerProps) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return <Drawer {...props} disablePortal={!isMounted} keepMounted={true} />;
};
